<!-- 分布统计弹框 -->
<template>
  <div class="distribution-statistics">
    <n-data-table
      max-height="658"
      :columns="columns"
      :data="data.tableData"
      :pagination="false"
      :bordered="false"
    />
  </div>
</template>

<script>
import { h } from 'vue'
export default {
  props: ['data'],
  data() {
    return {
      columns: [
        {
          title: '序号',
          key: 'no',
          width: 60,
          align: 'center',
          render(row, index) {
            return h(
              `span`,
              {},
              {
                default: () => index + 1,
              }
            )
          },
        },
        {
          title: '网格员',
          key: 'username',
          width: 120,
          align: 'center',
        },
        {
          title: '河流名称',
          key: 'hl',
          width: 120,
          align: 'center',
        },
        {
          title: '起点名称',
          key: 'qdmc',
          width: 120,
          align: 'center',
        },
        {
          title: '终点名称',
          key: 'zdmc',
          width: 120,
          align: 'center',
        },
        {
          title: '重点监管点',
          key: 'prints',
          width: 220,
          align: 'center',
          ellipsis: {
            tooltip: {
              trigger: 'hover',
            },
            'line-clamp': 3,
          },
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.distribution-statistics {
  :deep(.n-data-table) {
    width: 760px;
    margin: 0 auto;
    --n-border-color-modal: #ffffff00 !important;
    --n-th-color-modal: #ffffff00 !important;
    --n-td-color-hover-modal: #ffffff00 !important;
    --n-td-color-modal: #ffffff00 !important;
    tbody {
      tr:nth-of-type(odd) {
        background: #ffffff0d;
      }
      tr:hover {
        background: #ffffff26;
      }
      td {
        padding: 5px 5px 0 5px;
        height: 80px;
      }
    }
  }
}
</style>
